// src/components/ReturnToTop.tsx
import React, { memo } from 'react';

interface ReturnToTopProps {
  isVisible: boolean;
  onClick: () => void;
}

const ReturnToTop: React.FC<ReturnToTopProps> = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  const isMobile = window.innerWidth < 768;

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 100,
    opacity: isVisible ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    pointerEvents: isVisible ? 'auto' : 'none',
  };

  const buttonStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '12px 16px' : '10px 14px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    cursor: 'pointer',
    fontFamily: '"Inter", sans-serif',
    fontSize: isMobile ? '14px' : '13px',
    fontWeight: 500,
    color: '#1A1A1A',
    userSelect: 'none',
    minWidth: isMobile ? '100px' : '90px',
    transition: 'all 0.2s ease',
  };

  const arrowsStyle: React.CSSProperties = {
    fontSize: isMobile ? '16px' : '14px',
    lineHeight: 1,
    marginBottom: '4px',
    color: '#666',
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick();
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    target.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
    target.style.transform = 'translateY(-1px)';
    target.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
    target.style.transform = 'translateY(0)';
    target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
  };

  return (
    <div style={containerStyle}>
      <div 
        style={buttonStyle}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div style={arrowsStyle}>↑</div>
        <div>Return to top</div>
      </div>
    </div>
  );
};

export default memo(ReturnToTop);